import environments from "../environment";

function getUploadBaseUrl() {
	const configuredUploadRoot = String(environments.uploadRoot || "").trim();
	if (configuredUploadRoot) {
		return configuredUploadRoot.replace(/\/+$/, "");
	}

	const configuredApiRoot = String(environments.apiRoot || "").trim();
	if (!configuredApiRoot) {
		return "";
	}

	return configuredApiRoot.replace(/\/api\/?$/, "");
}

export function resolveAssetUrl(value?: string | null) {
	const normalizedValue = String(value || "").trim();
	if (!normalizedValue) {
		return normalizedValue;
	}

	if (
		/^([a-z]+:)?\/\//i.test(normalizedValue) ||
		normalizedValue.startsWith("data:") ||
		normalizedValue.startsWith("blob:")
	) {
		return normalizedValue;
	}

	if (!normalizedValue.startsWith("/uploads/")) {
		return normalizedValue;
	}

	const uploadBaseUrl = getUploadBaseUrl();
	if (!uploadBaseUrl) {
		return normalizedValue;
	}

	return `${uploadBaseUrl}${normalizedValue}`;
}
